
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import AdminEditCategory from "../../Components/Admin/AdminEditCategory";
import SideBar from "../../Components/Admin/SideBar";

const AdminEditCategoryPage = () => {
  return (

    <div className="d-flex justify-content-start">
      <div>
        <SideBar />
      </div>
      <div className="p-4" style={{ width: '100%' }}>
      <AdminEditCategory/>

        
      </div>
    </div>

  );
};

export default AdminEditCategoryPage;
